import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2';
import axios from 'axios';

const Footer = () => {
  const [newslatterEmail, setNewslatterEmail] = useState("");

  // const handleNewsLatterSubmit = (e) => {
  //   e.preventDefault();
  //   if (!newslatterEmail || !newslatterEmail.trim() || (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(newslatterEmail))) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text: "Please enter a valid email address"
  //     });
  //   }
  //   else {
  //     try {
  //       const formData = new FormData();
  //       formData.append("email", newslatterEmail);
  //       axios.post(`https://app.liveluckier.com/mobilenumerology/backend/admin/client/save_newslatter`, formData)
  //         .then((response) => {
  //           if (response.data.status === true) {
  //             Swal.fire({
  //               icon: "success",
  //               title: "Details Submitted",
  //               text: "Your details have been submitted successfully.",
  //             });
  //            setNewslatterEmail("")
  //           } else {
  //             if (response.data.errors) {
  //               const errorMessages = Object.values(response.data.errors).join("\n");
  //               Swal.fire({
  //                 icon: "error",
  //                 title: "Validation Errors",
  //                 text: errorMessages,
  //               });
  //             } else {
  //               Swal.fire({
  //                 icon: "error",
  //                 title: "Error",
  //                 text: response.data.message || "Something went wrong.",
  //               });
  //             }
  //           }
  //         })
  //     } catch (error) {
  //       console.log("error in axios call")
  //       Swal.fire({
  //         icon: "error",
  //         title: "Error",
  //         text:
  //           error.response?.data?.message ||
  //           error.message ||
  //           "Something went wrong. Please try again.",
  //       });
  //     }
  //     setNewslatterEmail("");
  //   }
  // }
  return (
    <div className="footer-container">
      {/* <section className="newslatter-container">
        <form onSubmit={handleNewsLatterSubmit}>
          <div className="row w-100 p-0 m-0 d-flex flex-column justify-content-center align-items-center gap-3">
            <div className="col-auto">
              <p className="pt-2 title">
                Sign up for our newsletter
              </p>
            </div>
            <div className="col-10">
              <div className="input-data">
                <input type="text" placeholder='Enter email address'  required value={newslatterEmail} onChange={(e) => setNewslatterEmail(e.target.value)} />
                <div className="underline"></div>
              </div>
            </div>
            <div className="col-auto">
              <button data-mdb-ripple-init type="submit" className="subscribe-btn">
                Subscribe
              </button>
            </div>
          </div>
        </form>
      </section> */}


      <footer className="py-3 mt-4">
        {/* <ul className="nav justify-content-center border-bottom pb-3 mb-3 footer-links-container">
          <li className="nav-item">
            <Link to="/" className="nav-link px-2 footer-link me-4">Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/Faq" className="nav-link px-2 footer-link me-4">FAQs</Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link px-2 footer-link me-4">About</Link>
          </li>
        </ul> */}
        <p className="text-center footer-link">© 2025 Numerology, All rights reserved</p>
      </footer>
    </div>
  )
}

export default Footer

